import { useCallback } from "react";

import { useLaunchParams } from "@tma.js/sdk-react";
import invariant from "tiny-invariant";

import { useHolderStore } from "shared/stores/holder-store";
import { generateHolderCommitment } from "shared/tg/utils/generate-holder-commitment";
import { getPrivateKey } from "shared/tg/utils/get-private-key";

export const useInitHolder = () => {
  const [holder, setHolder] = useHolderStore();
  const { tgWebAppData } = useLaunchParams();

  const initHolder = useCallback(async () => {
    if (holder) return holder;

    invariant(tgWebAppData?.user?.id, "tgWebAppData.user.id is undefined");

    const privateKey = await getPrivateKey(tgWebAppData.user.id);
    const holderCommitmentData = await generateHolderCommitment(privateKey);
    const newHolder = { privateKey, ...holderCommitmentData };
    setHolder(newHolder);

    return newHolder;
  }, [holder, setHolder, tgWebAppData?.user?.id]);

  return initHolder;
};
